export default __webpack_public_path__ + "static/media/silder1.577c632b.png";